import { formatPercent } from "nemuru-components";
import React from "react";
import Text from "../../../../shared/components/Text";

export const getFeeAmountAndInsuranceConditionsText = (
  setupFeeType,
  setupFeePercentage
) => {
  // const insuranceType = loanConditions.insuranceType; // TODO!
  switch (setupFeeType) {
    case "type_upfront":
      return (
        <Text
          tId={"INCLUDES_UPFRONT_SETUP_FEE_AMOUNT"}
          dynamicDataTexts={[formatPercent(setupFeePercentage)]}
        />
      );
    case "type_financed":
      return (
        <Text
          tId={"INCLUDES_FINANCED_SETUP_FEE_AMOUNT"}
          dynamicDataTexts={[formatPercent(setupFeePercentage)]}
        />
      );
    default:
      return null;
  }
};
